import Wrapper from '@app/Wrapper.js'

Munio.ShopCart = class extends Wrapper {
  component() {
    return import('./App.vue')
  }
}
